<template>
  <tn-list :list="list" v-bind="$attrs" v-on="$listeners">
    <!--<span slot="title" slot-scope="prop">-->
    <!--<div>{{prop.row.courseName}}</div>-->
    <!--<div>{{prop.row.classRoom}}</div>-->
    <!--</span>-->
    <div slot-scope="prop">
      <div class="course-name">
        {{prop.row.courseName}}
        <span class="f-fr" v-show="user.userType !== 3">{{prop.row.teacherName}}</span>
      </div>
      <div class="course-name" v-show="user.userType === 3">
        <span class="f-gery">{{prop.row.courseCode}}</span>
      </div>
      <div class="course-name f-gery" v-show="user.userType === 3">
        {{prop.row.className}}
      </div>
      <div class="van-clearfix" v-show="!simplify">
        <span class="f-fl">
          第{{prop.row.startSection}}-{{prop.row.endSection}}节
          <span v-show="prop.row.period" v-if="prop.row.period">
            {{prop.row.period}}周
          </span>
        </span>
        <span class="f-fr">{{prop.row.classRoom}}</span>
      </div>
    </div>
  </tn-list>
</template>
<script>
  export default {
    name: 'class-info-list',
    props: {
      list: {
        type: Array,
        required: true
      },
      simplify: Boolean
    },
    computed: {
      user() {
        return this.$store.state.user;
      }
    }
  };
</script>
